import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';

@Component({
  selector: 'switch-panel-toggle',
  template: `
    <i
      class="fa fa-lg is-clickable"
      [ngClass]="element.hidden ? 'fa-chevron-down' : 'fa-chevron-up'"
      (click)="toggle()"
    ></i>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SwitchPanelToggleComponent implements OnInit {
  @Input() public element: HTMLElement;
  @Input() public storageKey?: string;
  @Input() public open: boolean;

  public ngOnInit(): void {
    if (this.element === undefined || this.element === null) {
      return;
    }

    const stored = this.readStoredState();
    this.element.hidden = stored === undefined ? !this.open : !stored;
  }

  public toggle(): void {
    this.element.hidden = !this.element.hidden;
    this.persistState(!this.element.hidden);
  }

  private readStoredState(): boolean | undefined {
    if (this.storageKey === undefined) {
      return;
    }

    const stored = localStorage.getItem(this.storageKey);
    if (stored === null) {
      return;
    }

    try {
      return JSON.parse(stored);
    } catch {
      return undefined;
    }
  }

  private persistState(open: boolean): void {
    if (this.storageKey === undefined) {
      return;
    }

    try {
      localStorage.setItem(this.storageKey, JSON.stringify(open));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to persist panel state in localStorage', error);
    }
  }
}
